export const DeleteEntityByFullUid = `
    mutation deleteEntityByFullUid ($fullUid: String!)  {
        deleteEntityByFullUid (input: {fullUid: $fullUid}) {
            entity {
                geoType
                fullUid
                name
                membertype
                websiteurl
                notes
                instruc
                datelastchanged
                description
                document
                layerid
            }
        }
    }
`
